import { makeStyles } from '@material-ui/styles';
import ProductThumbnail from '@components/products/thumbnail';

const useStyles = makeStyles({
    wrapper: {
        display: 'grid',
        gridTemplateColumns: '50px 1fr',
        gap: 10,
        borderRadius: 4,
        marginTop: 8,
        padding: '4px',
    },
    brand: {
        fontSize: 12,
        fontFamily: 'Chronicle, "Open Sans"',
        lineHeight: 1.8,
        marginBottom: 8,
    }
}, { name: 'ProductNotify' });

export default function ProductNotify({product}) {
    const classes = useStyles();

    if (!product) {
        return null;
    }

    return (
        <div className={classes.wrapper}>
            <ProductThumbnail image={product.cover} alt={product.translated?.name} size={550}/>
            <section className={classes.product}>
                <span className={classes.brand}>{product?.manufacturer?.translated?.name?.toUpperCase()}</span><br/>
                <span className={classes.name}>{product?.translated?.name}</span>
            </section>
        </div>
    );
}
